module.exports = __webpack_public_path__ + "images/homepage-step1.svg";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-step1.svg
// module id = 852
// module chunks = 0